export const assinaturaTemplateEmailFundacao = `
	<p style="line-height: 0.8;"><strong>Relações com Investidores Institucionais</strong></p>\n
	<p style="line-height: 0.8;">ri@azquest.com.br</p>\n
	<p style="line-height: 0.8;">clientesinstitucionais@unifinance.com.br</p>\n
	<p style="line-height: 0.8;">Tel. (21) 3138-6514</p>\n
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>\n
	<p style="color: #B0B0B0; line-height: 0.8;">A Unifinance AAI é distribuidora exclusiva dos fundos da AZ Quest para Entidade
	Fechada de Previdência Complementar – EFPC. Instituições contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.</p>\n
	<p style="line-height: 0.8;"><a href="https://www.unifinance.com.br" target="_blank">www.unifinance.com.br</a></p>\n
`

export const assinaturaTemplateEmailIsmael = `
<div style="font-family: Arial, Helvetica, sans-serif; background-color: white; color: #242424; font-size: 14px; line-height: 1.5;">

  <p style="margin-top: 10px;">Estou à disposição para qualquer eventualidade.</p>

  <p style="margin-top: 10px;">Atenciosamente,</p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 14px; font-weight: bold; color: #1d252c;">
    Ismael Ramos, CFP<sup style="font-size: 10px;">®</sup>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 13px; color: #1d252c;">
    Candidato ao CFA Nível III
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    <a href="mailto:ri@azquest.com.br" style="color: #1d252c;">ri@azquest.com.br</a><br>
    <a href="mailto:ismael.ramos@unifinance.com.br" style="color: #1d252c;">ismael.ramos@unifinance.com.br</a>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    Tel: (21) 3138-6506 / (21) 97173-1290
  </p>

  <p>
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 10pt; color: #7f7f7f;">
    A Unifinance AAI é distribuidora exclusiva dos fundos da AZ Quest para Entidades Fechadas de Previdência Complementar – EFPC. Instituições contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.
  </p>

   <a href="www.unifinance.com.br" style="margin-top: 10px;">www.unifinance.com.br</a>
</div>

`

export const assinaturaTemplateEmailMatheus = `
	<div style="font-family: Arial, Helvetica, sans-serif; background-color: white; color: #242424; font-size: 14px; line-height: 1.5;">

  <p style="margin-top: 10px;">Estou à disposição para qualquer eventualidade.</p>

  <p style="margin-top: 10px;">Atenciosamente,</p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 14px; font-weight: bold; color: #1d252c;">
    Matheus Giannini<sup style="font-size: 10px;">®</sup>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    <a href="mailto:ri@azquest.com.br" style="color: #1d252c;">ri@azquest.com.br</a><br>
    <a href="matheus@unifinance.com.br" style="color: #1d252c;">matheus@unifinance.com.br</a>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 12px; color: #1d252c;">
    Tel: (21) 3138-6514
  </p>

  <p>
	<div class="header">
		<img src="https://django-unifinance.s3.us-east-1.amazonaws.com/media/imagem-unifinance.png" alt="Logo" style="width: 200px; height: auto;">
	</div>
  </p>

  <p style="font-family: 'Century Gothic', sans-serif; font-size: 10pt; color: #7f7f7f;">
    A Unifinance AAI é distribuidora exclusiva dos fundos da AZ Quest para Entidades Fechadas de Previdência Complementar – EFPC. Instituições contratantes: BEM, BNY Mellon, Intrag e BTG Pactual.
  </p>

  <a href="www.unifinance.com.br" style="margin-top: 10px;">www.unifinance.com.br</a>
</div>
`